// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1081":"128c0a86","6984":"3f75cb0e","8810":"3f75cb0e","9487":"a2267fc0"}[chunkId] + ".chunk.css";
};